export default [
  'bhf',
  'gstt-nutrition',
  'johns',
  'mount-sinai-stroke',
  'mymsaa',
  'ovacome',
  'share-breast-cancer-support',
  'share-metastatic-support',
  'share-ovarian-cancer-support',
  'share-uterine-cancer-support',
];
